<main role="main" class="mt-4">
  <div class="row">
    <h4 class="my-2 text-center">WIJIS Workflow Services Login</h4>

    <div class="col-8">
      <app-home></app-home>
    </div>

    <div class="col-4 my-auto">
      @if (!isPasswordResetEnabled) {
        <div class="w-100">
          <!-- Alerts: announce to AT -->
          @if (successMsg) {
            <div class="alert alert-success" role="alert" aria-live="polite">
              <h4 class="alert-heading">{{ successMsg[0] }}</h4>{{ successMsg[1] }}
            </div>
          }
          @if (responseMessage) {
            <div class="alert alert-danger" role="alert" aria-live="assertive">
              <h4 class="alert-heading">{{ responseMessage[0] }}</h4>{{ responseMessage[1] }}
            </div>
          }
          <!-- Submit on Enter anywhere in the form -->
          <form [formGroup]="loginForm" (ngSubmit)="loginUser()" aria-describedby="login-help">
            <p id="login-help" class="visually-hidden">
              Enter your username and password, then select the Login button.
            </p>
            <div class="form-group">
              <label for="username">Username</label>
              <input id="username" type="text" class="form-control" formControlName="username"
                placeholder="Enter Username" autocomplete="username"
                [attr.aria-invalid]="loginForm.get('username')?.invalid && loginForm.get('username')?.touched ? 'true' : null"
                aria-describedby="user-dec" />
                <!-- Use visually-hidden instead of display:none; screen readers ignore display:none -->
                <div id="user-dec" class="visually-hidden">This is the input for username.</div>
              </div>
              <div class="form-group mb-3">
                <label for="password">Password</label>
                <input id="password" type="password" class="form-control" formControlName="password"
                  placeholder="Enter Password" autocomplete="current-password"
                  [attr.aria-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched ? 'true' : null" />
                </div>
                <!-- Explicit button types -->
                <button type="submit" class="btn btn-primary btn-sm me-3 px-4">Login</button>
                <button type="button" class="btn btn-danger btn-sm px-4" (click)="reset()">Reset</button>
              </form>
            </div>
          }

          @if (isPasswordResetEnabled) {
            <div class="w-100">
              @if (responseMessage) {
                <div class="alert alert-danger" role="alert" aria-live="assertive">
                  <h4 class="alert-heading">{{ responseMessage[0] }}</h4>{{ responseMessage[1] }}
                </div>
              }
              <div class="mb-2">
                <form [formGroup]="resetPasswordForm" aria-describedby="reset-help">
                  <p id="reset-help" class="visually-hidden">
                    Generate a new password and then select Reset Password.
                  </p>
                  <div class="form-group">
                    <label for="newPassword" class="form-label">New Password</label><span class="c-red"></span>
                    <div class="input-group">
                      @if (resetPasswordForm.get('newPassword').value != null) {
                        <input id="newPassword" type="text" readonly
                          formControlName="newPassword" class="form-control" placeholder="New Password"
                          autocomplete="new-password" />
                      }
                      <button type="button" class="btn btn-outline-secondary" placement="top"
                        triggers="mouseenter:mouseleave focusin:focusout"
                        ngbPopover="Warning - Make sure you copy the above password now. We don't store it and you will not be able to see it again."
                        (click)="generatePass('edit')">
                        Generate Password
                      </button>
                    </div>
                    <app-control-message [control]="resetPasswordForm.get('newPassword')"
                    [message]="{ required: 'Field is requried' }"></app-control-message>
                  </div>
                </form>
              </div>
              @if (resetPasswordForm.get('newPassword').value != null) {
                <button class="btn btn-primary btn-sm me-3 px-4" type="button"
                  (click)="resetPassword()">
                  Reset Password
                </button>
              }
            </div>
          }
        </div>

        <p class="para text-center">
          This is a protected resource. Only registered database users can log in. Guest Users are not permitted access
        </p>
      </div>
    </main>
